import { render } from "./LegoSet.vue?vue&type=template&id=3282b4c1"
import script from "./LegoSet.vue?vue&type=script&lang=ts"
export * from "./LegoSet.vue?vue&type=script&lang=ts"
script.render = render

export default script